export function getNewValue<Value>(
    value: string[] | number[] | Value[] | undefined = [],
    optionValue: string | number | Value,
    checked: boolean,
    defaultEmptyValue: undefined | Value[] = [],
) {
    const newValue = [...value];
    if (checked) {
        newValue.push(optionValue);
    } else {
        newValue.splice(newValue?.indexOf?.(optionValue), 1);
        if (!newValue?.length) return defaultEmptyValue;
    }
    return newValue;
}
